
import axios from 'axios';
import { DownloadStudyBrowserReport, BestCTReportParams } from '../_models';
import { APP_CONFIGS } from './../_constants/config.constants';

const downloadStudyBrowserReport = (reportData: DownloadStudyBrowserReport) => {
    return axios.post('/api/v1/reports/study-browser', reportData, {responseType: 'blob'});
}

const getTotalCycleTimes = (factoryId: number, modules: string[]) => {
    return axios.get('/api/v1/reports/totalcycletime/', {
        params: {factoryId : factoryId, modules: modules}}
    );
}
const getBestCTReportData = (params:BestCTReportParams) => {
    return axios.get('/api/v1/studies/getBestCTReport/', {
        params: params}
    );
}

const downloadBestCTReportData= (params: BestCTReportParams) => {
    window.open(`${APP_CONFIGS.API_BASE}/api/v1/studies/downloadBestCTReport?sbuCode=${params.sbuCode}&plantCode=${params.plantCode}&factoryCode=${params.factoryCode}&style=${params.style}&Subscription-Key=${APP_CONFIGS.APIM_SUBSCRIPTION_KEY}`)
}

const getPowerBiReport = (reportType: string) => {
    return axios.get('/api/v1/reports/getPowerBiReport/', {
        params: {reportType : reportType}}
    );
}

export const reportService = {
    downloadStudyBrowserReport,
    getTotalCycleTimes,
    getPowerBiReport,
    getBestCTReportData,
    downloadBestCTReportData
}
